// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3a063a13","977":"a6f63304"}[chunkId] + ".chunk.js";
};